import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class CardSlide extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get title() {
    return get(this, '_title.value', '');
  }

  get description() {
    return get(this, '_description.value', '');
  }

  get logo() {
    return get(this, '_logo.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/CardSlide.model.js